import { createBrowserHistory } from 'history';
import dva from 'dva';
import immer from 'dva-immer';
import createLoading from 'dva-loading';

import applicantModel from './models/applicant';
import childModel from './models/child';
import childrenModel from './models/children';
import elkModel from './models/elk';
import spouseModel from './models/spouse';
import agreementsModel from './models/agreements';
import modalsModel from './models/modals';
import auth from './models/auth';
import submitModel from './models/submit';
import steps from './models/steps';
import notHiddenChildrenModel from './models/notHiddenChildren';
import notifications from './models/notifications';

export const basename = '/services/mnogodetnaya-semia/';

export const browserHistory = createBrowserHistory({
  basename: basename,
});

browserHistory.listen(({ pathname }) => {
  if (!/new/.test(pathname)) return;
  window.location.reload();
});

const app = dva({
  history: browserHistory,
  onError(e, dispatch) {
    // eslint-disable-next-line no-console
    console.error(e);
  },
});

app.use(createLoading());
app.use(immer());

app.model(auth);
app.model(applicantModel);
app.model(childModel);
app.model(childrenModel);
app.model(elkModel);
app.model(spouseModel);
app.model(agreementsModel);
app.model(modalsModel);
app.model(submitModel);
app.model(steps);
app.model(notHiddenChildrenModel);
app.model(notifications);

export default app;
